module.exports = __webpack_public_path__ + "static/media/copyLinkIcon.8f739662.svg";